import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import OutOfOfficeItemComponent from './OutOfOfficeItemComponent';
import { sequence } from '@totalsoft/change-tracking-react';
import { isDirty } from '@totalsoft/change-tracking';
import { IconButton } from '@totalsoft/rocket-ui';

export const OutOfOfficeListComponent = ({
  replacements,
  saveOutOfOfficeDisabled,
  onAddNewItem,
  outOfOfficeLens,
  outOfOfficeLensDirtyInfo,
  validationInfo,
  onSave,
  addOutOfOfficeDisabled
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} display='flex' gap={1} justifyContent='end'>
        <IconButton
          color='primary'
          variant='text'
          disabled={addOutOfOfficeDisabled}
          onClick={onAddNewItem}
          tooltip={t('User.OutOfOffice.Summary.AddButton')}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          color='primary'
          variant='text'
          disabled={saveOutOfOfficeDisabled || !isDirty(outOfOfficeLensDirtyInfo)}
          onClick={onSave}
          tooltip={t('User.OutOfOffice.Summary.SaveButton')}
        >
          <SaveIcon />
        </IconButton>
      </Grid>
      {(outOfOfficeLens |> sequence).map((item, index) => {
        return (
          <Grid item key={index} xs={12}>
            <OutOfOfficeItemComponent replacements={replacements} index={index} itemLens={item} validationInfo={validationInfo[index]} />
          </Grid>
        );
      })}
    </Grid>
  );
};

OutOfOfficeListComponent.propTypes = {
  replacements: PropTypes.array,
  saveOutOfOfficeDisabled: PropTypes.bool.isRequired,
  addOutOfOfficeDisabled: PropTypes.bool.isRequired,
  onAddNewItem: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  outOfOfficeLens: PropTypes.object.isRequired,
  outOfOfficeLensDirtyInfo: PropTypes.object,
  validationInfo: PropTypes.object
};

export default OutOfOfficeListComponent;
